import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=a5e7b9d0&scoped=true&"
import script from "./Common.vue?vue&type=script&lang=js&"
export * from "./Common.vue?vue&type=script&lang=js&"
import style0 from "./Common.vue?vue&type=style&index=0&id=a5e7b9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e7b9d0",
  null
  
)

export default component.exports